import { useState, useEffect } from 'react'
import { SignalSlashIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { pwaService } from '../services/pwaService'

export default function OfflineIndicator() {
  const [networkState, setNetworkState] = useState(pwaService.getNetworkState())
  const [showOfflineAlert, setShowOfflineAlert] = useState(false)

  useEffect(() => {
    const updateState = () => {
      const newState = pwaService.getNetworkState()
      setNetworkState(newState)

      // 显示离线提示
      if (!newState.isOnline) {
        setShowOfflineAlert(true)
      } else {
        setShowOfflineAlert(false)
      }
    }

    const unsubscribe = pwaService.subscribe(updateState)
    updateState()

    return () => {
      unsubscribe()
    }
  }, [])

  if (networkState.isOnline) {
    return null
  }

  return (
    <>
      {/* 顶部离线指示器 */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-amber-50 border-b border-amber-200">
        <div className="px-4 py-2">
          <div className="flex items-center justify-center">
            <SignalSlashIcon className="h-4 w-4 text-amber-600 mr-2" />
            <span className="text-sm text-amber-800">
              当前处于离线状态，部分功能可能受限
            </span>
          </div>
        </div>
      </div>

      {/* 离线提示弹窗 */}
      {showOfflineAlert && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
            <div className="flex items-center justify-center w-12 h-12 mx-auto bg-amber-100 rounded-full mb-4">
              <ExclamationTriangleIcon className="h-6 w-6 text-amber-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
              网络连接已断开
            </h3>
            <p className="text-sm text-gray-500 text-center mb-4">
              您当前处于离线状态。仍可查看已缓存的内容，但需要网络连接的功能暂时不可用。
            </p>
            <button
              onClick={() => setShowOfflineAlert(false)}
              className="w-full bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </>
  )
}